// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8svog","active":"styles_active__VdyIM"};